<ngb-toast
  *ngFor="let toast of toasts$ | async; index as i"
  (hidden)="remove(toast)"
  [delay]="toast.delay"
  [attr.data-test-id]="'toast-message' + '-' + i"
  class="text-white"
  [ngClass]="{
    success: toast.message.level === 'SUCCESS',
    'bg-danger': toast.message.level === 'ERROR'
  }"
>
  <ng-container *ngFor="let item of toast.message.content; index as i">
    <ng-container [ngSwitch]="item.type">
      <ng-template [ngSwitchCase]="'text'"
        ><span [innerHTML]="item.value | translate: item?.translateParams"></span>
      </ng-template>

      <ng-template [ngSwitchCase]="'signup'">
        <a [routerLink]="REGISTRATION_LINK" (click)="remove(toast)" [attr.data-test-id]="'signup-link-' + i">
          {{ item.value | translate }}
        </a>
      </ng-template>

      <ng-template [ngSwitchCase]="'email'">
        <a [attr.href]="'mailto:' + item.value" (click)="remove(toast)" [attr.data-test-id]="'mailto-link-' + i">{{
          item.value
        }}</a>
      </ng-template>
    </ng-container>
  </ng-container>
</ngb-toast>
